import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormControl from './FormControl';
import classNames from 'classnames';
import { Field } from 'formik';

class TextArea extends Component {
  render() {
    return (
      <FormControl label={this.props.label}
        className={classNames(
          'form-item-textfield',
          this.props.className,
        )}
        showThrobber={this.props.showThrobber}
        name={this.props.name}>
        <Field
          as="textarea"
          name={this.props.name}
          id={this.props.name}
          placeholder={this.props.placeholder}
          disabled={this.props.disabled}
          rows={this.props.rows} />
      </FormControl>
    );
  }
}

TextArea.defaultProps = {
  className: [],
  validations: [],
  label: '',
  showThrobber: false,
  value: '',
  rows: 4,
  mapped: false
};

TextArea.propTypes = {
  className: PropTypes.array,
  validations: PropTypes.array,
  label: PropTypes.string,
  showThrobber: PropTypes.bool,
  value: PropTypes.string,
  rows: PropTypes.number,
  mapped: PropTypes.bool
};

export default TextArea;
